// extracted by mini-css-extract-plugin
export default {"base":"wO9f6","contentContainer":"BwlOA","addTaskBtn":"FcfNw"};